import {
  AvatarResponse,
  TransectionResponse,
  UserProfile,
} from '@/types/user';
import apiSlice from './apiSlice';
import { cleanParams } from '@/utils/helper';
export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET /users/me
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
        params: { t: Date.now() },
      }),
      providesTags: ['UserDetails'],
    }),

    updateUserInfo: builder.mutation<
      { success: boolean; data: any; message?: string },
      {
        id: string | number;
        username: string;
        dialCode?: string;
        mobile?: string;
        country?: string | undefined;
        mobileVerificationCode?: string;
      }
    >({
      query: (body) => ({
        url: `users/me`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['UserDetails'],
    }),
    updateProfileImage: builder.mutation<
      { success: boolean; message: string },
      { profileImage: string }
    >({
      query: (body) => ({
        url: '/users/me/profile-image',
        method: 'POST',
        body,
      }),

      invalidatesTags: ['UserDetails'],
    }),
    getMyAvtars: builder.query<AvatarResponse, void>({
      query: () => ({
        url: '/avatars',
        method: 'GET',
        params: { t: Date.now() },
      }),
    }),
    getUserTransections: builder.query<
      TransectionResponse,
      { skip?: number; take?: number; search?: string; type?: string } | void
    >({
      query: (params) => ({
        url: '/users/me/transactions',
        method: 'GET',
        params: cleanParams(params ?? {}),
      }),
      keepUnusedDataFor: 0, // ← don't serve stale cache
      providesTags: ['quizlist'],
    }),
    addDeviceToken: builder.mutation<
      { success: boolean; data: any; message?: string },
      {
        token: string;
        deviceType: string;
        platform: string;
      }
    >({
      query: (body) => ({
        url: `/users/me/device-token`,
        method: 'POST',
        body,
      }),
    }),
   
  }),
  overrideExisting: false,
});

export const {
  useGetUserProfileQuery,
  useUpdateUserInfoMutation,
  useUpdateProfileImageMutation,
  useGetMyAvtarsQuery,
  useGetUserTransectionsQuery,
  useAddDeviceTokenMutation,

} = userApi;
